import React, { useState, useEffect } from "react";

import 'react-quill/dist/quill.snow.css';
import CatalogService from "../../services/catalog.service";
import AdminService from "../../services/admin.service";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";

const AdminMaintenance = () => {
    const [maintenance, setMaintenance] = useState();
    const { isSuperAdmin } = useSelector(state => state.auth);
    const [message, setMessage] = useState("");
    const [styleCode, setStyleCode] = useState("");

    useEffect(() => {
        async function fetchData() {
            const maintenance = await AdminService.getMaintenance();
            setMaintenance(maintenance.data);
        }
        fetchData();
    }, []);

    const updateAllSanmar = async () => {
        const response = await CatalogService.updateAllSanmar();
        console.log("Update All Sanmar Response", response);
        setMessage(response.message);
    }

    const updateSanmarSizes = async () => {
        const response = await AdminService.updateSanmarSizes();
        console.log("Update All Sanmar Sizes", response);
        setMessage(response.message);
    }

    const updateSanmarSizesForStyle = async () => {
        const response = await AdminService.updateSanmarSizesForStyle(styleCode);
        console.log("Update All Sanmar Sizes", response);
        setMessage(response.message);
    }

    const allStyleReport = async () => {
        const response = await AdminService.allStyleReport();
        console.log("All Style Report Response", response);
    }

    const syncFromSDL = async () => {
        const response = await AdminService.syncFromSDL();
        console.log("Sync From SDL Response", response);
        setMessage(response.message);
    }


    return (

        <div className="user-details-container">
            <h2>Maintenance</h2>
            {isSuperAdmin &&
                <Container className="user-data">
                    <Row>
                        <Col className="title">
                            <Button onClick={updateAllSanmar} disabled={maintenance?.refreshRunning}>Update All Sanmar Products</Button>
                            <p>{message}</p>
                            <p>Note: this process takes about 1.5 hours to complete.</p>
                            {maintenance?.refreshRunning && <p>Refresh is currently running.</p>}
                            <p>Last Refresh: {maintenance?.lastRefresh}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="title">
                            <Button onClick={updateAllSanmar} disabled={maintenance?.refreshRunning}>Update Pricing</Button>
                            <p>{message}</p>
                            <p>Note: this process takes about 1.5 hours to complete.</p>
                            {maintenance?.refreshRunning && <p>Refresh is currently running.</p>}
                            <p>Last Refresh: {maintenance?.lastRefresh}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="title">
                            <Button onClick={allStyleReport}>Generate All Style Report</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="title">
                            <Button onClick={updateSanmarSizes}>Update All Sizes</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="title">
                            <input type="text" name="style" id="style" onChange={(e) => setStyleCode(e.target.value)}/><br/>
                            <Button onClick={updateSanmarSizesForStyle}>Update Sizes For Style</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="title">
                            <Button onClick={syncFromSDL} disabled={maintenance?.refreshRunning}>Sync From SDL File</Button>
                            <p>Updates pricing, colors, and styles from SanMar_SDL_N.csv.</p>
                            <p>New products will be added with images. Existing products will NOT have images updated.</p>
                            <p>Products not in the SDL file will be marked for deletion.</p>
                        </Col>
                    </Row>
                </Container>
            }
        </div>
    );
};
export default AdminMaintenance;